// import React from 'react';

// const services = [
//   {
//     title: 'Local Rides',
//     iconClass: 'fa-solid fa-car-side',
//     description: 'Anywhere in the City',
//   },
//   {
//     title: 'Airport Transfer',
//     iconClass: 'fa-solid fa-plane-departure',
//     description: '24/7 Pickup & Drop',
//   },
//   {
//     title: 'Outstation',
//     iconClass: 'fa-solid fa-road',
//     description: '200+ Cities Served',
//   },
//   {
//     title: 'One Way Drop',
//     iconClass: 'fa-solid fa-location-arrow',
//     description: 'Pay One Way Only',
//   },
//   {
//     title: 'Round Trip',
//     iconClass: 'fa-solid fa-arrows-rotate',
//     description: 'Return Travel Deals',
//   },
//   {
//     title: 'Tour Packages',
//     iconClass: 'fa-solid fa-suitcase-rolling',
//     description: 'Explore with Comfort',
//   },
// ];

// const ActivitySection = () => {
//   return (
//     <section className="activity-section">
//       <div className="container">
//         {/* Section Heading */}
//         <div className="section-heading text-center">
//           <div className="row">
//             <div className="col-lg-8 offset-lg-2">
//               <h5 className="dash-style">SERVICES BY CATEGORY</h5>
//               <h2>OUR CAB SERVICES</h2>
//               <p>
//                 Prince Cabs offers a wide range of professional, affordable and comfortable cab services across city, airport and long-distance travel.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Activity Grid */}
//         <div className="activity-inner row">
//           {services.map((service, index) => (
//             <div className="col-lg-2 col-md-4 col-sm-6" key={index}>
//               <div className="activity-item text-center">
//                 <div className="activity-icon mb-3">
//                   <a href="#">
//                     <i className={service.iconClass} style={{ fontSize: '2.5rem', color: '#f9a826' }}></i>
//                   </a>
//                 </div>
//                 <div className="activity-content">
//                   <h4>
//                     <a href="#">{service.title}</a>
//                   </h4>
//                   <p>{service.description}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ActivitySection;


import React from "react";

const services = [
  { title: "Local Rides",       iconClass: "fa-solid fa-car-side",        description: "Anywhere in the City",            link: "/local-rides" },
  { title: "Airport Transfer",  iconClass: "fa-solid fa-plane-departure", description: "24/7 Pickup & Drop",              link: "/airport-transfer" },
  { title: "Outstation",        iconClass: "fa-solid fa-road",            description: "200+ Cities Served",              link: "/outstation" },
  { title: "One Way Drop",      iconClass: "fa-solid fa-location-arrow",  description: "Pay One Way Only",                link: "/one-way-drop" },
  { title: "Round Trip",        iconClass: "fa-solid fa-arrows-rotate",   description: "Return Travel Deals",             link: "/round-trip" },
  { title: "Tour Packages",     iconClass: "fa-solid fa-suitcase-rolling",description: "Explore with Comfort",            link: "/tour-packages" },
];

export default function ActivitySection() {
  return (
    <section className="pc-activity">
      <div className="container">
        <div className="text-center mb-4">
          <h5 className="pc-dash">SERVICES BY CATEGORY</h5>
          <h2 className="pc-heading">OUR CAB SERVICES</h2>
          <p className="pc-sub">
            Prince Cabs offers a wide range of professional, affordable and comfortable cab services across city, airport and long-distance travel.
          </p>
        </div>

        <div className="row g-3 justify-content-center pc-deck">
          {services.map((s, i) => (
            <div key={i} className="col-6 col-md-4 col-lg-3 col-xl-2 d-flex">
              <a href={s.link} className="pc-card w-100" aria-label={s.title}>
                <span className="pc-icon">
                  <i className={s.iconClass} aria-hidden="true" />
                </span>
                <h4 className="pc-title">{s.title}</h4>
                <p className="pc-desc">{s.description}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
